var _rect, _rect2, _rect3, _rect4, _rect5, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMoth = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 8.414,
  height: 19.463,
  fill: "currentColor",
  rx: 4.207,
  transform: "matrix(-1 0 0 1 19.703 4.14)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 3.276,
  height: 3.339,
  fill: "currentColor",
  rx: 1.638,
  transform: "matrix(-1 0 0 1 18.99 .64)"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 3.276,
  height: 3.339,
  fill: "currentColor",
  rx: 1.638,
  transform: "matrix(-1 0 0 1 15.279 .64)"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 17.76,
  height: 2.633,
  fill: "#fff",
  rx: 1.316,
  transform: "matrix(-1 0 0 1 24.376 8.522)"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 17.76,
  height: 2.633,
  fill: "#fff",
  rx: 1.316,
  transform: "matrix(-1 0 0 1 24.376 13.738)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.267 22.257c-2.603 0-4.434-2.56-3.594-5.023l2.249-6.598a4.863 4.863 0 0 1 4.602-3.294.54.54 0 0 1 .54.54V18.46c0 2.098-1.7 3.798-3.797 3.798ZM24.657 22.257c2.603 0 4.435-2.56 3.595-5.023l-2.249-6.598A4.863 4.863 0 0 0 21.4 7.342a.54.54 0 0 0-.54.54V18.46c0 2.098 1.7 3.798 3.797 3.798Z"
})));
export default SvgMoth;